<template>
  <card class="card-user">
    <div slot="image">
      <img src="@/assets/img/background-profile.png"
        style="height:180px;"
        alt="..."/>
    </div>
    <div>
      <div class="author">
        <img
          class="avatar"
          src="@/assets/img/icon-user.svg"
          alt="..."
        />
        <h4 class="title">
          {{CompleteName}}
          <br />
          <a href="#">
            <small>{{UserEmail}}</small>
          </a>
        </h4>
      </div>
      <hr/>
      <p class="description text-center">
        Pérfil(es):
        <br/>
        <b>{{getRol}}</b>
      </p>
    </div>
  </card>
</template>
<script>
import auth from '../../token'
export default {
  computed: {
    CompleteName() {
      return auth.getName();
    },
    UserEmail() {
      return auth.getEmail();
    },
    getRol () {
      return localStorage.getItem('role')
    },
  },
  data() {
    return {
    };
  }
};
</script>
<style></style>
